import { autoUpdate, flip, offset, shift, useClick, useDismiss, useFloating, useHover, useInteractions, useRole, useTransitionStyles } from '@floating-ui/react';
import { useControlledValue } from '~/hooks';
function usePopover(options) {
    const { onOpenChange, open: openProp, placement: placementProp = 'bottom', defaultOpen = false, offset: offsetProp = 10, dismissProps, clickProps, roleProps, transitionProps, hoverProps } = options;
    const [open, setOpen] = useControlledValue({ defaultProp: defaultOpen, prop: openProp });
    const { context, refs, floatingStyles, isPositioned, placement, update, x, y } = useFloating({
        middleware: [flip({ padding: 10 }), shift({ padding: 10 }), offset(offsetProp)],
        open,
        onOpenChange: (open) => {
            setOpen(open);
            onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
        },
        placement: placementProp,
        whileElementsMounted: autoUpdate
    });
    const click = useClick(context, clickProps);
    const dismiss = useDismiss(context, dismissProps);
    const role = useRole(context, roleProps);
    const hover = useHover(context, hoverProps);
    const { isMounted, styles } = useTransitionStyles(context, Object.assign(Object.assign({}, transitionProps), { common: floatingStyles }));
    const { getFloatingProps, getReferenceProps } = useInteractions([click, dismiss, role, hover]);
    return {
        getPopoverProps: getFloatingProps,
        getTriggerProps: getReferenceProps,
        isMounted,
        isPositioned,
        open: open !== null && open !== void 0 ? open : false,
        placement,
        popoverStyles: styles,
        refs,
        update,
        x,
        y
    };
}
export default usePopover;
//# sourceMappingURL=use-popover.js.map